import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import {
  setUidToken,
  setDocumentTitle,
  getMediaType,
  numberThumbnail,
  isVoca,
} from 'src/helper/tool'
import lang from './lang'
import http from 'src/helper/http'
import { jumpToUser, toAppShow, getDeviceInfo } from 'src/helper/webviewFun.js'
import { getlangV2, setlang } from 'src/helper/getlang'
import SVGA from 'svgaplayerweb'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.min.css'
import Toast from 'src/component/Toast'
import MediaModal from 'src/component/media-modal'
import dsBridge from 'dsbridge'
import { compareVersion } from 'src/helper/domain'

const rtlList = ['ar', 'fa', 'ur']
@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: lang.en,
    language: 'en',
    tabIndex: 0,
    oneRanking: {
      cp1: {
        uid: null,
        duid: 'Yayya',
        nickname: 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      cp2: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      days: 0,
      level: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
    },
    twoRanking: {
      cp1: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      cp2: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      days: 0,
      level: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
      currWeekScore: 0,
    },
    threeRanking: {
      cp1: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      cp2: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      days: 0,
      level: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
      currWeekScore: 0,
    },
    userInfo: {
      nickname: '',
      uid: 10000,
      duid: 'Yayya',
      avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
    },
    showAnother: {
      anotherCp: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: 'waiting...',
        avatarurl: '/img/activity/couplesNew/img_avatar_waiting.png',
        headUrl: '',
        svgaScale: 0,
      },
      days: 0,
      level: {
        level: 0,
        title: 'LV0 First glance',
        score: 0,
      },
      nextLevel: {
        level: 1,
        title: 'LV1 Growing fond',
        score: 0,
      },
    },
    rulesLink: '',
    giftItem: [],
    cpJoin: [],
    showModalValue: 0,
    hadOne: true,
    showSvga: true,
    giftWallList: [],
    dayNum: 0,
    hourNum: 0,
    minNum: 0,
    secondNum: 0,
    fiveList: [],
    myCpList: [],
    delName: '',
    delUid: null,
    chanegCp: {
      cp1: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      cp2: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      days: 0,
      level: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
      nextLevel: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
    },
    oldchanegCp: {
      cp1: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      cp2: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      days: 0,
      level: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
      nextLevel: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
    },
    ganderNum: 3,
    changeItem: 0,
    inLevel: 0,
    topOneReward: [],
    topLostReward: [],
    topBanner: [],
    showOlsdModal: -1,
    closeCp: {},
    toastContent: '',
    closeArr: [
      ['one', ''],
      ['two', '80K'],
      ['three', '250K'],
      ['four', '850K'],
      ['five', '3.5M'],
      ['six', '16.8M'],
      ['seven', '126M'],
    ],
    levelList: [],
    rowList: [],
    inRegion: false,
    lostWeekCp: {
      cp1: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      cp2: {
        uid: null,
        duid: isVoca() ? 'Voca' : 'Yayya',
        nickname: isVoca() ? 'Voca' : 'Yayya',
        avatarurl: isVoca() ? '/img/voca-home/default_avatarurl@2x.webp' : '/img/icon-bg.png',
      },
      days: 0,
      level: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
      nextLevel: {
        level: 0,
        title: 'lv0',
        score: 0,
      },
    },
    mediaVisible: false,
    activeMedia: {},
    bindingRewrdTitleList: {
      en: '/img/activity/couplesNew/binding_rewrd_title_en.png',
      tr: '/img/activity/couplesNew/binding_rewrd_title_tr.png',
      ar: '/img/activity/couplesNew/binding_rewrd_title_ar.png',
      ru: '/img/activity/couplesNew/binding_rewrd_title_ru@2x.webp',
      uz: '/img/activity/couplesNew/binding_rewrd_title_uz@2x.webp',
    },
    howTobecomeList: {
      en: '/img/activity/couplesNew/how_tobecome_en.png',
      tr: '/img/activity/couplesNew/how_tobecome_tr.png',
      ar: '/img/activity/couplesNew/how_tobecome_ar.png',
      ru: '/img/activity/couplesNew/how_tobecome_ru@2x.webp',
      uz: '/img/activity/couplesNew/how_tobecome_uz@2x.webp',
    },
    rankingTitleList: {
      en: '/img/activity/couplesNew/ranking_title_en.png',
      tr: '/img/activity/couplesNew/ranking_title_tr.png',
      ar: '/img/activity/couplesNew/ranking_title_ar.png',
      ru: '/img/activity/couplesNew/ranking_title_ru@2x.webp',
      uz: '/img/activity/couplesNew/ranking_title_uz@2x.webp',
    },
    startYourLoveImg: {
      en: '/img/activity/couplesNew/start_your_love_en.png',
      ar: '/img/activity/couplesNew/start_your_love_ar.png',
      tr: '/img/activity/couplesNew/start_your_love_tr.png',
    },
    bindingRewrdTitleImg: {
      en: '/img/activity/couplesNew/binding_rewrd_title_en.png',
      tr: '/img/activity/couplesNew/binding_rewrd_title_tr.png',
      ar: '/img/activity/couplesNew/binding_rewrd_title_ar.png',
    },
    howTobecomeImg: {
      en: '/img/activity/couplesNew/how_tobecome_en.png',
      tr: '/img/activity/couplesNew/how_tobecome_tr.png',
      ar: '/img/activity/couplesNew/how_tobecome_ar.png',
    },
    rankingTitleImg: {
      en: '/img/activity/couplesNew/ranking_title_en.png',
      tr: '/img/activity/couplesNew/ranking_title_tr.png',
      ar: '/img/activity/couplesNew/ranking_title_ar.png',
    },
    cpSqureImg: {
      en: '/img/activity/couplesNew/CP_Squre_en.png',
      tr: '/img/activity/couplesNew/CP_Squre_tr.png',
      ar: '/img/activity/couplesNew/CP_Squre_ar.png',
    },
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlangV2(language, lang)
    let langObj = setlang(language, lang)
    if (isVoca()) {
      for (let key in langObj) {
        if (langObj[key] && typeof langObj[key] === 'string') {
          langObj[key] = langObj[key].replace(/(Yayya|hoby)/, 'Voca')
        }

        if (Array.isArray(langObj[key])) {
          langObj[key] = langObj[key].map((item) => {
            if (typeof item === 'string') {
              return item.replace(/(Yayya|hoby)/, 'Voca')
            }
            return item
          })
        }
      }
    }
    this.setState({
      lang: langObj,
      language: language == 'zh' ? 'en' : language,
    })
    const uid = await setUidToken(this.props.location.query)
    this.setKey = `${uid}myCpListId`
    await this.inSetPage(uid)
  }

  async componentDidMount() {
    setDocumentTitle('CP')
    if (isVoca()) {
      const favicon = document.querySelector('link[rel="icon"]')
      favicon.href = '/img/favicon_ico_new.png'
    }
    // 初始化时检查弹窗状态
    this.handleBodyScroll(this.state.showModalValue)
  }

  componentDidUpdate(prevProps, prevState) {
    // 监听弹窗状态变化，控制背景滚动
    if (prevState.showModalValue !== this.state.showModalValue) {
      this.handleBodyScroll(this.state.showModalValue)
    }
  }

  componentWillUnmount() {
    // 组件卸载时恢复背景滚动
    this.handleBodyScroll(0)
  }

  // 控制背景滚动的方法
  handleBodyScroll = (showModalValue) => {
    const body = document.body
    const html = document.documentElement

    if (showModalValue === 1) {
      // 弹窗打开时，禁止背景滚动
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      body.style.position = 'fixed'
      body.style.top = `-${scrollTop}px`
      body.style.width = '100%'
      body.style.overflow = 'hidden'
      html.style.overflow = 'hidden'

      // 保存当前滚动位置
      this.savedScrollTop = scrollTop

      // 阻止 touchmove 事件（移动端）
      document.addEventListener('touchmove', this.preventDefault, { passive: false })
    } else {
      // 弹窗关闭时，恢复背景滚动
      body.style.position = ''
      body.style.top = ''
      body.style.width = ''
      body.style.overflow = ''
      html.style.overflow = ''

      // 恢复滚动位置
      if (this.savedScrollTop !== undefined) {
        window.scrollTo(0, this.savedScrollTop)
        this.savedScrollTop = undefined
      }

      // 移除 touchmove 事件监听
      document.removeEventListener('touchmove', this.preventDefault)
    }
  }

  // 阻止默认滚动行为（仅用于弹窗背景）
  preventDefault = (e) => {
    // 如果事件发生在弹窗内部的可滚动区域，允许滚动
    const scrollableArea = e.target.closest('.root-show')
    if (scrollableArea) {
      // 在可滚动区域内，允许滚动
      return
    }

    // 检查是否在弹窗内部（但不在可滚动区域）
    const modal = document.querySelector('.show-rules-modle')
    if (modal && modal.contains(e.target)) {
      // 在弹窗内但不在可滚动区域，阻止滚动
      e.preventDefault()
      return
    }

    // 在弹窗外部，阻止滚动
    e.preventDefault()
  }

  inSetPage = async (uid) => {
    this.setState({ uid: uid })
    let losUid = await localStorage.getItem('cpuids')
    if (losUid != uid) {
      await localStorage.setItem(this.setKey, -1)
      await localStorage.setItem('cpuids', uid)
    }
    const _that = this
    const mySwiper = new Swiper('.swiper-container', {
      autoHeight: true,
      on: {
        slideChange: function (e) {
          if (e.activeIndex == 1) {
            let dom = document.querySelectorAll('#rootamin')
            for (let index = 0; index < dom.length; index++) {
              _that.setItemAnimation(index, dom[index])
            }
          }
          _that.setState({ tabIndex: e.activeIndex })
        },
      },
    })
    this.mySwiper = mySwiper
    await this.getUserInfo(uid)
    this.getRankingList()
    this.getGiftList()
    this.getUserCpList(uid)
    this.getCpGiftWall()
    this.getCpLevel()
    try {
      let dom = document.querySelector('#top-petal')
      let startdom = document.querySelector('#one-strat')
      let buili = new SVGA.Player('#one-strat')
      let builifn = new SVGA.Parser('#one-strat')
      let topPetal = new SVGA.Player('#top-petal')
      let topPetalfn = new SVGA.Parser('#top-petal')
      topPetalfn.load(
        '/img/activity/couplesNew/ani_event_cp_kv_starglow_loop.svga',
        function (videoItem) {
          topPetal.setVideoItem(videoItem)
          topPetal.startAnimation()
        },
      )
      builifn.load('/img/activity/couplesNew/levelStar.svga', function (videoItem) {
        buili.setVideoItem(videoItem)
      })
      let topStart = new SVGA.Player('#top-start')
      let topStartfn = new SVGA.Parser('#top-start')
      topStartfn.load(
        '/img/activity/couplesNew/ani_event_cp_kv_petal_loop.svga',
        function (videoItem) {
          topStart.setVideoItem(videoItem)
          topStart.startAnimation()
        },
      )
      window.addEventListener('scroll', () => {
        // viewPortHeight 兼容所有浏览器写法
        try {
          this.topsvgaId && clearTimeout(this.topsvgaId)
          this.topsvgaId = setTimeout(() => {
            const viewWidth = window.innerWidth || document.documentElement.clientWidth
            const viewHeight = window.innerHeight || document.documentElement.clientHeight
            const { top, right, bottom, left } = dom.getBoundingClientRect()
            let domcof = top >= -140 && left >= 0 && right <= viewWidth && bottom <= viewHeight
            if (domcof) {
              topStart.startAnimation()
              topPetal.startAnimation()
            } else {
              topStart.stopAnimation()
              topPetal.stopAnimation()
            }
          }, 400)
          this.cp_spureId && clearTimeout(this.cp_spureId)
          this.cp_spureId = setTimeout(() => {
            const viewWidth = window.innerWidth || document.documentElement.clientWidth
            const viewHeight = window.innerHeight || document.documentElement.clientHeight
            if (startdom) {
              const { top, right, bottom, left } = startdom.getBoundingClientRect()
              let cp_serps = top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight
              if (cp_serps) {
                buili.startAnimation()
              } else {
                buili.stopAnimation()
              }
            }
          }, 400)
        } catch (error) {}
      })
      this.getLastWeekCp()
    } catch (error) {}
  }
  setKey = null

  shoScDom = null
  shoScroll = (e) => {
    return
    !this.shoScDom && (this.shoScDom = e)
    this.opCardId && clearTimeout(this.opCardId)
    this.opCardId = setTimeout(() => {
      for (let index = 0; index < this.liveDomArr.length; index++) {
        let itemArr = this.liveDomArr[index]
        const e = itemArr[2]
        console.log(itemArr, 'dasdada9958555555')
        let boundaryValue =
          e.getBoundingClientRect().top - e.getBoundingClientRect().top - e.offsetHeight
        console.log(e.scrollTop > boundaryValue)
        if (e.scrollTop > boundaryValue) {
          console.log('开始了下标为' + index + '的动画')
          itemArr[0].startAnimation()
        } else {
          console.log('停止了下标为' + index + '的动画')
          itemArr[0].stopAnimation()
        }
      }
    }, 200)
  }

  opCardId = null

  getLastWeekCp = async () => {
    let { oldchanegCp } = this.state
    let res = await http.post('/web/cp/last_week_top1')
    // console.log(res,'------resresres-----')
    if (res.code == 0) {
      if (res.data == null || !res.data.cp_id) return
      this.setState({
        lostWeekCp: res.data,
      })
    }
  }
  setItemAnimation(index, el) {
    let { rowList } = this.state
    el.style.animation = `danmu ${rowList[index].length * 5}s linear infinite normal` // linear infinite
  }

  getUserCpList = async (uid) => {
    let keyss = this.setKey
    let res = await http.post('/web/cp/list/my')
    if (res.code == 0) {
      if (res.data.length == 0) return
      let cpmuList = [...res.data]
      let changeItem = 0
      let obj = res.data[0]
      let myCpListId = localStorage.getItem(keyss)
      let i = cpmuList.findIndex((item) => item.cp_id == myCpListId)
      if (myCpListId >= 0 && i >= 0) {
        let arr = [...cpmuList]
        obj = arr[i]
        arr.splice(i, 1)
        cpmuList = [obj, ...arr]
      } else {
        localStorage.setItem(keyss, res.data[0].cp_id)
      }
      this.getConfObj(uid, obj)
      this.setState({
        inLevel: obj.level.level + 1,
        myCpList: cpmuList,
        changeItem,
        chanegCp: obj,
        hadOne: !(cpmuList.length > 1),
      })
    }
  }

  getConfObj = (uid, obj) => {
    let cof = obj.cp1.uid == uid
    let c = {
      anotherCp: obj[cof ? 'cp2' : 'cp1'],
      days: obj.days,
      level: obj.level,
      nextLevel: obj.nextLevel,
    }
    this.setState({ showAnother: c })
  }

  getRankingList = async () => {
    let { threeRanking } = this.state
    let res = await http.post('/web/cp/week/rank')
    if (res.code == 0) {
      this.countDown(res.data.countdown)
      if (res.data.list.length < 1) return
      let list = res.data.list
      let arr = [...res.data.list]
      let ac = res.data.list.length >= 4 ? arr.slice(3, 11) : []
      this.setState({
        fiveList: ac,
        oneRanking: list[0]
          ? { ...list[0].cpItem, currWeekScore: list[0].currWeekScore }
          : threeRanking,
        twoRanking: list[1]
          ? { ...list[1].cpItem, currWeekScore: list[1].currWeekScore }
          : threeRanking,
        threeRanking: list[2]
          ? { ...list[2].cpItem, currWeekScore: list[2].currWeekScore }
          : threeRanking,
      })
    }
  }

  countDown = (times) => {
    let doms = document.querySelectorAll('.time-num')
    let lastday = 0
    let lasthoust = 0
    let lastMins = 0
    var timer = null
    timer = setInterval(() => {
      var day = 0,
        hour = 0,
        minute = 0,
        second = 0
      if (times > 0) {
        day = Math.floor(times / (60 * 60 * 24))
        hour = Math.floor(times / (60 * 60)) - day * 24
        minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
        second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
      }
      if (doms.length < 0) return
      if (day != lastday) {
        doms[0].innerHTML = day
        lastday = day
      }
      if (hour != lasthoust) {
        doms[1].innerHTML = hour <= 9 ? '0' + hour : hour
        lasthoust = hour
      }
      if (minute != lastMins) {
        doms[2].innerHTML = minute <= 9 ? '0' + minute : minute
        lastMins = minute
      }
      doms[3].innerHTML = second <= 9 ? '0' + second : second
      times--
    }, 1000)
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  topsvgaId = null

  cp_spureId = null

  getGiftList = async () => {
    let res = await http.post('/web/cp/gift_reward')
    if (res.code == 0) {
      this.setState({ cpJoin: res.data.cpGift })
    }
  }

  getCpGiftWall = async () => {
    let res = await http.post('/web/cp/gift_wall')
    if (res.code == 0) {
      let arr = [[], [], []]
      res.data.forEach((item, index) => {
        if (index % 3 == 2) {
          arr[2].push(item)
        } else if (index % 3 == 1) {
          arr[1].push(item)
        } else if (index % 3 == 0) {
          arr[0].push(item)
        }
      })
      this.setState({ giftWallList: res.data, rowList: arr })
    }
  }

  score(e) {
    e = e * 1 || 0
    if (e > 1000000) {
      e = (parseInt(e / 100000) / 10).toFixed(1) + 'M'
    } else if (e >= 1000) {
      e = (parseInt(e / 100) / 10).toFixed(1) + 'K'
    }
    return e || `- -`
  }

  upShwo = (e) => {
    if (e > 1000000) {
      e = (e / 100000 / 10).toFixed(2) + 'M'
    }
    return e || `- -`
  }

  getTopReward = async (ganderNum) => {
    let res = await http.post('web/setting', {
      keys: ['cp.rank_reward', 'cp_first_bind_reward', 'cp_activity_rule_pic'],
    })
    if (res.code == 0) {
      let name = ['shenmiren', 'male', 'female'] // 1男 2女
      let ganederIndex = ganderNum == 1 ? ganderNum : ganderNum == 2 ? ganderNum : 0
      let aar = [[], [], []]
      let banner = []
      let fistBiding = []
      for (let index = 0; index < name.length; index++) {
        res.data['cp.rank_reward'][index].forEach((item) => {
          if (
            item.gender == name[ganederIndex] ||
            (item.gender == 'male' && name[ganederIndex] == 'shenmiren')
          ) {
            // 修复没有设置性别不显示的问题，默认男
            aar[index].push(item)
            if (item.reward_type == 'banner') {
              banner.push(item)
            }
          }
        })
      }
      res.data.cp_first_bind_reward.forEach((item) => {
        if (item.gender == name[ganederIndex]) {
          fistBiding.push(item)
        }
      })

      this.setState({
        topOneReward: aar[0],
        topLostReward: [aar[1], aar[2]],
        topBanner: banner,
        giftItem: fistBiding,
        rulesLink: res.data.cp_activity_rule_pic,
      })
    }
  }

  getUserInfo = async (uid) => {
    let res = await http.post('/web/MyAccountInfo', { uid })
    if (res.code == 0) {
      this.setState({
        userInfo: {
          nickname: res.data.nickname,
          uid: res.data.uid,
          duid: res.data.duid,
          avatarurl: res.data.avatarurl,
          region: res.data.region || 'en',
        },
      })
      this.getTopReward(res.data.gender)
    }
  }

  // 根据用户 region 获取奖励名称，默认使用 en
  getRewardName = (item) => {
    const { userInfo } = this.state

    const region = userInfo.region ? userInfo.region : 'en'
    return item[`reward_name_${region}`] || item.reward_name_en
  }

  progrFn = () => {
    let { chanegCp } = this.state
    let a = (chanegCp.level.score / chanegCp.nextLevel.score) * 100
    // console.log(a, 'dsada')
    return `-${100 - a.toFixed(2) - 12}%`
  }

  progrFnItem = (item) => {
    let a = (item.level.score / item.nextLevel.score).toFixed(2) * 100
    return `-${100 - a.toFixed(2) - 12}%`
  }

  closeCpRequset = async (id) => {
    let keystr = this.setKey
    let c = localStorage.getItem(keystr)
    let { myCpList, oldchanegCp, lang } = this.state
    let arr = [...myCpList]
    this.setState({ showOlsdModal: 0 })
    let b = arr.findIndex((item) => item.cp_id == id)
    arr.splice(b, 1)
    if (c == id) {
      if (arr.length > 0) {
        localStorage.setItem(keystr, arr[0].cp_id)
      } else {
        localStorage.setItem(keystr, 0)
      }
    }
    let res = await http.post('/web/cp/cancel', { cpId: id })
    if (res.code == 0) {
      await this.setState({ toastContent: lang.unbind_toast1 })
      this.refs.toast.hideRule(true)
      this.setState({
        myCpList: arr.length == 0 ? [] : arr,
        hadOne: !(arr.length > 1),
      })
      if (id == c) {
        if (arr.length == 0) {
          await this.setState({ chanegCp: oldchanegCp })
        } else {
          await this.setState({ chanegCp: arr[0] })
        }
        this.setState({ changeItem: 0 })
      }
      this.changeSuorp()
    } else {
      if (res.code == 2) {
        await this.setState({ toastContent: lang.unbind_toast2 })
        this.refs.toast.hideRule(true)
      } else {
        this.setState({ toastContent: lang.unbind_toast2 })
        this.refs.toast.hideRule(true)
      }
    }
  }

  closeCpfn = () => {
    let { closeCp } = this.state
    this.closeCpRequset(closeCp.cp_id)
  }

  getChangeCpLv = () => {
    let { inLevel } = this.state
    let ar = ['zro', 'one', 'two', 'three', 'five', 'four', 'six', 'seven']
    return `${ar[inLevel]}`
  }

  setInfoItem = (e) => {
    this.setState({ changeItem: e })
  }

  changeCpObj = async () => {
    let keystr = this.setKey
    let { changeItem, myCpList } = this.state
    let changObj = myCpList[changeItem]
    localStorage.setItem(keystr, changObj.cp_id)
    let newArr = [...myCpList]
    newArr.splice(changeItem, 1)
    let b = [changObj, ...newArr]
    await this.setState({ chanegCp: changObj, showModalValue: 0, myCpList: b, changeItem: 0 })
    this.changeSuorp()
  }

  changeSuorp = () => {
    let { chanegCp, uid } = this.state
    this.getConfObj(uid, chanegCp)
    let inlevel = chanegCp.level.level
    this.setState({ inLevel: inlevel + 1 })
  }

  mySwiper = null

  handleSetTabCard = (e) => {
    this.setState({ tabIndex: e })
    this.mySwiper.slideTo(e, 600, false)
    if (e == 1) {
      let dom = document.querySelectorAll('#rootamin')
      for (let index = 0; index < dom.length; index++) {
        this.setItemAnimation(index, dom[index])
      }
    }
  }

  openMyCard = () => {
    let keystr = this.setKey
    let { myCpList } = this.state
    let c = localStorage.getItem(keystr)
    this.timeId && clearTimeout(this.timeId)
    c = myCpList.findIndex((item) => item.cp_id == c)
    let b = myCpList.length
    this.setState({ showModalValue: 1, changeItem: c })
    this.timeId = setTimeout(() => {
      for (let index = 0; index < b; index++) {
        new SVGA.autoload(document.querySelector(`#heat-red-svga${index}`))
      }
      this.setState({ showSvga: false })
    }, 200)
  }

  liveDomArr = []
  setDomew = (item) => {
    let { uid } = this.state
    let name = ''
    let id = null
    if (item.cp1.uid == uid) {
      name = item.cp2.nickname
      id = item.cp2.uid
    } else {
      name = item.cp1.nickname
      id = item.cp1.uid
    }
    this.setState({ showOlsdModal: 1, closeCp: item, delName: name, delUid: id })
  }

  // 设置播放对象
  onSetActiveMedia = async (media) => {
    if (!media.preview) return

    const deviceInfo = await getDeviceInfo()
    if (
      dsBridge.hasNativeMethod('toAppShow') &&
      compareVersion(deviceInfo.res.version || '', '5.3.0') === 1
    ) {
      console.log('原生播放')
      toAppShow({
        loopUrl: media.preview,
        loop: 1,
        loopType: getMediaType(media.show_type, media.preview),
      })
    } else {
      this.setState({
        activeMedia: {
          show_url: media.preview,
          vap_json: media.vap_info,
        },
        mediaVisible: true,
      })
      console.log('h5播放1')
      console.log({
        show_url: media.preview,
        vap_json: media.vap_info,
      })
    }
  }

  // 关闭 MediaModal
  onCloseMediaModal = () => {
    this.setState({
      mediaVisible: false,
      activeMedia: {},
    })
  }

  getCpLevel = async () => {
    let res = await http.post('/web/cp/level')
    if (res.code === 0) {
      this.setState({
        levelList: res.data,
      })
      console.log(res.data)
    }
  }

  getBindingRewrdTitle() {
    let { language, bindingRewrdTitleList } = this.state

    if (language === 'ar') {
      return (
        <img
          style={{ width: '1.88rem', height: '0.44rem' }}
          className="title-img"
          src={bindingRewrdTitleList['ar']}
        />
      )
    }

    if (language === 'ru') {
      return (
        <img
          style={{ width: '1.38rem', height: '0.58rem', marginTop: '.42rem' }}
          className="title-img"
          src={bindingRewrdTitleList['ru']}
        />
      )
    }

    if (language === 'uz') {
      return (
        <img
          style={{ width: '3.08rem', marginLeft: '0.79rem', marginTop: '.5rem' }}
          className="title-img"
          src={bindingRewrdTitleList['uz']}
        />
      )
    }

    return (
      <img
        className="title-img"
        src={bindingRewrdTitleList[language] || bindingRewrdTitleList['en']}
      />
    )
  }

  gethowTobecomeTitle() {
    const { language, howTobecomeList } = this.state
    if (language === 'ar') {
      return (
        <img
          style={{ width: '1.92rem', height: '0.5rem' }}
          className="title-img"
          src={howTobecomeList['ar']}
        />
      )
    }

    if (language === 'ru') {
      return <img style={{ width: '2.06rem' }} className="title-img" src={howTobecomeList['ru']} />
    }

    if (language === 'uz') {
      return (
        <img
          style={{ width: '1.84rem', height: '0.67rem', marginLeft: '0.79rem', marginTop: '.4rem' }}
          className="title-img"
          src={howTobecomeList['uz']}
        />
      )
    }

    return <img className="title-img" src={howTobecomeList[language] || howTobecomeList['en']} />
  }

  render() {
    let {
      lostWeekCp,
      showAnother,
      rowList,
      toastContent,
      showOlsdModal,
      topBanner,
      topOneReward,
      topLostReward,
      closeArr,
      inLevel,
      changeItem,
      showSvga,
      myCpList,
      chanegCp,
      userInfo,
      delName,
      delUid,
      fiveList,
      threeRanking,
      twoRanking,
      language,
      hadOne,
      showModalValue,
      lang,
      rulesLink,
      tabIndex,
      oneRanking,
      cpJoin,
      giftItem,
      mediaVisible,
      activeMedia,
      levelList,
    } = this.state
    return (
      <div className={`couplesNew ${rtlList.includes(language) ? 'arlang' : ''}`}>
        <div
          id="top-start"
          className="top-start"
          src="/img/activity/couplesNew/ani_event_cp_kv_starglow_loop.svga"
        ></div>
        <div
          id="top-petal"
          className="top-petal"
          src="/img/activity/couplesNew/ani_event_cp_kv_petal_loop.svga"
        ></div>
        <div className="header-root">
          <div
            className={`rules-btn ${language}`}
            onClick={() => this.setState({ showModalValue: 2 })}
          >
            {lang.rules}
          </div>
          <div className="top-root-the">
            <div className="top-cp">
              <div className="top-one" onClick={() => jumpToUser(lostWeekCp.cp1.uid)}>
                <img className="top-header-img" src="/img/activity/couplesNew/top_header.png"></img>
                <img className="hie-top-atv" src={lostWeekCp.cp1.avatarurl}></img>
              </div>
              <div className="live-icon">
                <div className="day-num">{lostWeekCp.days}</div>
                <div className="day-text">{lang.days}</div>
              </div>
              <div className="top-two" onClick={() => jumpToUser(lostWeekCp.cp2.uid)}>
                <img className="hie-top-atv" src={lostWeekCp.cp2.avatarurl}></img>
                <img className="top-header-img" src="/img/activity/couplesNew/top_header.png"></img>
              </div>
            </div>
            <div className="cp-live">
              <span>{lostWeekCp.level.title}</span>
            </div>
            <div className="time-root" key={63551}>
              <div className="time-num">0</div>
              <div className="time-text">D</div>
              <div className="time-num">0</div>
              <div className="time-text">H</div>
              <div className="time-num">0</div>
              <div className="time-text">M</div>
              <div className="time-num">0</div>
              <div className="time-text">S</div>
            </div>
          </div>
        </div>
        <div className="gift-root">
          <div className="title-bg">
            <p>{lang.binding_reward}</p>
          </div>
          <div className="tips-in-the">{lang.cp_binding_reward_details1}</div>
          <div className="gitf-item">
            {giftItem.length > 0 &&
              giftItem.map((item, index) => (
                <div className="item" key={index}>
                  <div className="item-img" onClick={() => this.onSetActiveMedia(item)}>
                    {!!item.preview && (
                      <img className="item-img-play" src={`/img/icon_play@2x.png`} alt="" />
                    )}
                    <img className="" src={item.reward_pic} />
                  </div>
                  <div className="item-name">{this.getRewardName(item)}</div>
                </div>
              ))}
          </div>
        </div>
        <div className="tips-join-root">
          <div className="title-bg">
            <p>{lang.how_tobecome}</p>
          </div>
          <div className="in-the-root">
            <div className="left">
              <img style={{ width: '1.12rem', height: '1.12rem' }} src={cpJoin.image} />
            </div>
            <div className="right">{lang.how_to_become_cp_details1}</div>
          </div>
        </div>
        <div className="select-tab">
          <div
            className={`${tabIndex == 0 ? 'in-select' : 'on-select'}`}
            onClick={() => this.handleSetTabCard(0)}
          >
            {lang.ranking}
          </div>
          <div
            className={`${tabIndex == 1 ? 'in-select' : 'on-select'}`}
            onClick={() => this.handleSetTabCard(1)}
          >
            {lang.cp_square}
          </div>
          <div
            className={`${tabIndex == 2 ? 'in-select' : 'on-select'}`}
            onClick={() => this.handleSetTabCard(2)}
          >
            {lang.reward}
          </div>
        </div>
        <div className="swiper-container">
          <div className="swiper-wrapper">
            <div id="ranking-roots" className="ranking-root swiper-slide">
              <div className="title">
                <p>{lang.ranking_title}</p>
              </div>
              <div className="top-one">
                <div
                  className="top-num"
                  // style={{
                  //   [language !== 'ar' ? 'marginLeft' : 'marginRight']:
                  //     `${language !== 'ar' ? '2.88rem' : '3.06rem'}`,
                  // }}
                >
                  TOP 1
                </div>
                <div className="top-ingo">
                  <div className="atv-one" onClick={() => jumpToUser(oneRanking.cp1.uid)}>
                    <img
                      className="header-img"
                      src="/img/activity/couplesNew/head_top_one.png"
                    ></img>
                    <img className="atv-img" src={oneRanking.cp1.avatarurl}></img>
                    <div className="name-text">{this.score(oneRanking.currWeekScore)}</div>
                  </div>
                  <div
                    className="num-info"
                    style={{
                      marginLeft: `0.56rem`,
                      marginRight: `${language !== 'ar' ? '0.48rem' : '0.7rem'}`,
                    }}
                  >
                    <div className="day-num">{oneRanking.days}</div>
                    <div className="day-text">{lang.days}</div>
                    <div className="level-info">{oneRanking.level.title}</div>
                  </div>
                  <div className="atv-two" onClick={() => jumpToUser(oneRanking.cp2.uid)}>
                    <img
                      className="header-img"
                      src="/img/activity/couplesNew/head_top_one.png"
                    ></img>
                    <img className="atv-img" src={oneRanking.cp2.avatarurl}></img>
                    <div className="name-text">{this.score(oneRanking.currWeekScore)}</div>
                  </div>
                </div>
              </div>
              <div className="top-two lost">
                <div
                  className="num-top"
                  // style={{
                  //   [language !== 'ar' ? 'marginLeft' : 'marginRight']:
                  //     `${language !== 'ar' ? '3.46rem' : '3.56rem'}`,
                  // }}
                >
                  TOP 2
                </div>
                <div className="top-info">
                  <div
                    className="sroce-num"
                    style={{
                      [rtlList.includes(language === 'ar') ? 'marginRight' : 'marginLeft']:
                        '0.4rem',
                      [rtlList.includes(language === 'ar') ? 'marginLeft' : 'marginRight']:
                        '0.28rem',
                    }}
                  >
                    {this.score(twoRanking.currWeekScore)}
                  </div>
                  <div className="user-left" onClick={() => jumpToUser(twoRanking.cp1.uid)}>
                    <img
                      className="header-img"
                      src="/img/activity/couplesNew/lost_top_header.png"
                    ></img>
                    <img className="user-img" src={twoRanking.cp1.avatarurl}></img>
                    <div className="uset-text">{twoRanking.cp1.nickname}</div>
                  </div>
                  <div className="top-detail">
                    <div className="live-icon">
                      <div className="live-day">{twoRanking.days}</div>
                      <div className="live-num">{lang.days}</div>
                    </div>
                    <div className="live-level">{twoRanking.level.title}</div>
                  </div>
                  <div className="user-right" onClick={() => jumpToUser(twoRanking.cp2.uid)}>
                    <img
                      className="header-img"
                      src="/img/activity/couplesNew/lost_top_header.png"
                    ></img>
                    <img className="user-img" src={twoRanking.cp2.avatarurl}></img>
                    <div className="uset-text">{twoRanking.cp2.nickname} </div>
                  </div>
                </div>
              </div>
              <div className="top-two lost">
                <div
                  className="num-top"
                  // style={{
                  //   [!rtlList.includes(language) ? 'marginLeft' : 'marginRight']: `${
                  //     !rtlList.includes(language) ? '3.46rem' : '3.56rem'
                  //   }`,
                  // }}
                >
                  TOP 3
                </div>
                <div className="top-info">
                  <div
                    className="sroce-num"
                    style={{
                      [rtlList.includes(language) ? 'marginRight' : 'marginLeft']: '0.4rem',
                      [rtlList.includes(language) ? 'marginLeft' : 'marginRight']: '0.28rem',
                    }}
                  >
                    {this.score(threeRanking.currWeekScore)}
                  </div>
                  <div className="user-left" onClick={() => jumpToUser(threeRanking.cp1.uid)}>
                    <img
                      className="header-img"
                      src="/img/activity/couplesNew/lost_top_header.png"
                    ></img>
                    <img className="user-img" src={threeRanking.cp1.avatarurl}></img>
                    <div className="uset-text">{threeRanking.cp1.nickname}</div>
                  </div>
                  <div className="top-detail">
                    <div className="live-icon">
                      <div className="live-day">{threeRanking.days}</div>
                      <div className="live-num">{lang.days}</div>
                    </div>
                    <div className="live-level">{threeRanking.level.title}</div>
                  </div>
                  <div className="user-right" onClick={() => jumpToUser(threeRanking.cp2.uid)}>
                    <img
                      className="header-img"
                      src="/img/activity/couplesNew/lost_top_header.png"
                    ></img>
                    <img className="user-img" src={threeRanking.cp2.avatarurl}></img>
                    <div className="uset-text">{threeRanking.cp2.nickname} </div>
                  </div>
                </div>
              </div>
              <div style={{ minHeight: `${fiveList.length * 2.42}rem` }}>
                {fiveList.length > 0 &&
                  fiveList.map((item, index) => (
                    <div className="top-two heigie" key={index + 66}>
                      <div
                        className="num-top"
                        style={{
                          [!rtlList.includes(language) ? 'marginLeft' : 'marginRight']: `${
                            rtlList.includes(language)
                              ? index == 6
                                ? '3.58rem'
                                : '3.6rem'
                              : index == 6
                                ? '3.38rem'
                                : '3.44rem'
                          }`,
                        }}
                      >
                        {4 + index}
                      </div>
                      <div className="top-info">
                        <div
                          className="sroce-num"
                          style={{
                            [rtlList.includes(language) ? 'marginRight' : 'marginLeft']: '0.4rem',
                            [rtlList.includes(language) ? 'marginLeft' : 'marginRight']: '0.28rem',
                          }}
                        >
                          {this.score(item.currWeekScore)}
                        </div>
                        <div className="user-left" onClick={() => jumpToUser(item.cpItem.cp1.uid)}>
                          <img
                            className="header-img"
                            src="/img/activity/couplesNew/lost_top_header.png"
                          ></img>
                          <img className="user-img" src={item.cpItem.cp1.avatarurl || ''}></img>
                          <div className="uset-text">{item.cpItem.cp1.nickname}</div>
                        </div>
                        <div className="top-detail">
                          <div className="live-icon">
                            <div className="live-day">{item.cpItem.days}</div>
                            <div className="live-num">{lang.days}</div>
                          </div>
                          <div className="live-level">{item.cpItem.level.title}</div>
                        </div>
                        <div className="user-right" onClick={() => jumpToUser(item.cpItem.cp2.uid)}>
                          <img
                            className="header-img"
                            src="/img/activity/couplesNew/lost_top_header.png"
                          ></img>
                          <img className="user-img" src={item.cpItem.cp2.avatarurl || ''}></img>
                          <div className="uset-text">{item.cpItem.cp2.nickname}</div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div id="cp-squres" className="cp-squre swiper-slide">
              <div className="root-one">
                <div className="title-bg">
                  <p>{lang.cp_squre}</p>
                </div>
                <div className="tips">{lang.cp_gifts_wall_description1}</div>
                <div className="danmu-dse">
                  {rowList.length > 0 &&
                    rowList.map((item, index) => (
                      <div
                        className="rootamin"
                        id="rootamin"
                        style={{
                          top: `${['0.4rem', '1.4rem', '2.52rem'][index]}`,
                          [rtlList.includes(language) ? 'paddingLeft' : 'paddingRight']: '0',
                        }}
                        key={index}
                      >
                        {item.length > 0 &&
                          item.map((d, i) => {
                            return (
                              <div className="item" key={i + 10}>
                                <div className="item-atv">
                                  <div className="one-atv">
                                    <img
                                      className="haedersss"
                                      style={{ width: '0.8rem', height: '0.8rem' }}
                                      src="/img/activity/couplesNew/squre_item.png"
                                    />
                                    <img className="user-atv" src={d.cp_1.avatarurl} />
                                  </div>
                                  <div className="tow-atv">
                                    <img
                                      className="haedersss"
                                      style={{ width: '0.8rem', height: '0.8rem' }}
                                      src="/img/activity/couplesNew/squre_item.png"
                                    />
                                    <img className="user-atv" src={d.cp_2.avatarurl} />
                                  </div>
                                  <div className="what-gift">
                                    <img className="gift-img" src={d.gift.image} />
                                  </div>
                                </div>
                                <div className="item-text">{`${lang.insetTextL[(i * index) % 6]}`}</div>
                              </div>
                            )
                          })}
                        {item.length > 0 &&
                          item.map((d, i) => {
                            return (
                              <div className="item" key={i + 100}>
                                <div className="item-atv">
                                  <div className="one-atv">
                                    <img
                                      className="haedersss"
                                      style={{ width: '0.8rem', height: '0.8rem' }}
                                      src="/img/activity/couplesNew/squre_item.png"
                                    />
                                    <img className="user-atv" src={d.cp_1.avatarurl} />
                                  </div>
                                  <div className="tow-atv">
                                    <img
                                      className="haedersss"
                                      style={{ width: '0.8rem', height: '0.8rem' }}
                                      src="/img/activity/couplesNew/squre_item.png"
                                    />
                                    <img className="user-atv" src={d.cp_2.avatarurl} />
                                  </div>
                                  <div className="what-gift">
                                    <img className="gift-img" src={d.gift.image} />
                                  </div>
                                </div>
                                <div className="item-text">{`${lang.insetTextL[(i * index) % 6]}`}</div>
                              </div>
                            )
                          })}
                      </div>
                    ))}
                </div>
              </div>
              <div style={{ position: 'relative' }}>
                <div className="title-name">
                  <p>{lang.start_your_love}</p>
                </div>
                <div className="open-way">
                  <div
                    id="one-strat"
                    className={`${
                      ['one', 'two', 'three', 'four', 'five', 'six', 'seven'][
                        inLevel - 1 >= 0 ? inLevel - 1 : 0
                      ]
                    }-start-svga`}
                    src="/img/activity/couplesNew/levelStar.svga"
                  ></div>
                  {['one', 'two', 'three', 'four', 'five', 'six', 'seven'].map((item, index) => {
                    if (index > 0) {
                      return (
                        <img
                          className={`${item}-way-img ${inLevel == index + 1 ? 'smallBig' : ''}`}
                          key={index}
                          src={`/img/activity/couplesNew/${item}_way_${inLevel >= index + 1 ? 'in' : 'no'}.png`}
                        ></img>
                      )
                    } else {
                      return (
                        <img
                          className={`one-way-img ${inLevel == index + 1 ? 'smallBig' : ''}`}
                          key={index}
                          src={
                            inLevel > 1
                              ? '/img/activity/couplesNew/one_way_to.png'
                              : inLevel == 1
                                ? '/img/activity/couplesNew/one_way_in.png'
                                : '/img/activity/couplesNew/one_way_no.png'
                          }
                        ></img>
                      )
                    }
                  })}
                  <img
                    className="light-one"
                    src="/img/activity/couplesNew/way_light_sbcp.png"
                  ></img>
                  <img
                    className="light-two"
                    src="/img/activity/couplesNew/way_light_sbcp.png"
                  ></img>
                  <img
                    className="light-three"
                    src="/img/activity/couplesNew/way_light_sbcp.png"
                  ></img>
                  {levelList.map(
                    (item, index) =>
                      inLevel < index + 1 && (
                        <div className={`${closeArr[index][0]}-way-root`} key={index}>
                          <img
                            className="close-icon"
                            src="/img/activity/couplesNew/close_like_icon.png"
                          />
                          {index == 0 && <div className="close_bm_bg">Cp Ring</div>}
                          {index > 0 && (
                            <div className="close_bm_bg">
                              <div>{numberThumbnail(item.score)}</div>
                              <img src="/img/activity/couplesNew/gold_icon.png"></img>
                            </div>
                          )}
                        </div>
                      ),
                  )}
                  {inLevel == 2 && (
                    <img className="two-car" src="/img/activity/couplesNew/pink_car_left.png"></img>
                  )}
                  {inLevel == 3 && (
                    <img className="three-car" src="/img/activity/couplesNew/pink_car.png"></img>
                  )}
                  {inLevel == 4 && (
                    <img
                      className="four-car"
                      src="/img/activity/couplesNew/pink_car_left.png"
                    ></img>
                  )}
                  {inLevel == 5 && (
                    <img className="five-car" src="/img/activity/couplesNew/pink_car.png"></img>
                  )}
                  {inLevel == 6 && (
                    <img className="six-car" src="/img/activity/couplesNew/pink_car_left.png"></img>
                  )}
                  {inLevel == 7 && (
                    <img className="seven-car" src="/img/activity/couplesNew/pink_car.png"></img>
                  )}
                  {inLevel > 0 && (
                    <div className={`cp-info-live-${this.getChangeCpLv()}`}>
                      <div className="cp-left">
                        <img
                          className="header-img"
                          src="/img/activity/couplesNew/cp_pink_head.png"
                        ></img>
                        <img className="atv-img" src={chanegCp.cp1.avatarurl}></img>
                      </div>
                      <div
                        className="cp-right"
                        style={{
                          [rtlList.includes(language) ? 'marginLeft' : 'marginRight']: '-0.16rem',
                        }}
                      >
                        <img
                          className="header-img"
                          src="/img/activity/couplesNew/cp_pink_head.png"
                        ></img>
                        <img className="atv-img" src={chanegCp.cp2.avatarurl}></img>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div id="reward-tabs" className="reward-tab swiper-slide">
              <div className="top-one">
                <div
                  className="top-one-title"
                  style={{ [rtlList.includes(language) ? 'marginRight' : 'marginLeft']: '1.06rem' }}
                >
                  <img className="title-text" src={`/img/activity/couplesNew/top_one.png`}></img>
                </div>
                <div className="gift-item-root">
                  {topBanner.length > 0 &&
                    topBanner.map((item, index) => (
                      <div className="banner_bg" key={index}>
                        <div className="banner-item">
                          <div>
                            <img className="gift-img" src={item.reward_pic}></img>
                          </div>
                        </div>
                        <div className="banner-name">{this.getRewardName(item)}</div>
                      </div>
                    ))}
                  {topOneReward.length > 0 &&
                    topOneReward.map(
                      (item, index) =>
                        item.reward_type != 'banner' && (
                          <div
                            className="item"
                            key={index}
                            onClick={() => this.onSetActiveMedia(item)}
                          >
                            <img className="gift-img" src={item.reward_pic}></img>
                            {!!item.preview && (
                              <img className="gift-img-play" src={`/img/icon_play@2x.png`} alt="" />
                            )}
                            <div className="gitf-detail">{this.getRewardName(item)}</div>
                          </div>
                        ),
                    )}
                </div>
              </div>
              {topLostReward.length > 0 &&
                topLostReward.map((item, index) => (
                  <div className="top-lost" key={index + 125}>
                    <div
                      className="top-lost-title"
                      style={{
                        [rtlList.includes(language) ? 'marginRight' : 'marginLeft']: '1.06rem',
                      }}
                    >
                      <img
                        className="title-text"
                        src={`/img/activity/couplesNew/top_${['two', 'three'][index]}.png`}
                      ></img>
                    </div>
                    <div className="gift-item-root">
                      {/* { JSON.stringify(item) } */}
                      {item.length > 0 &&
                        item.map((i, d) => (
                          <div className="item" key={d} onClick={() => this.onSetActiveMedia(i)}>
                            <img className="gift-img" src={i.reward_pic}></img>
                            {!!i.preview && (
                              <img className="gift-img-play" src={`/img/icon_play@2x.png`} alt="" />
                            )}
                            <div className="gitf-detail">{this.getRewardName(i)}</div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="my-cp-root">
          <div
            className="change-show-cp"
            style={{
              width: `${language == 'tr' ? '1.8rem' : '1.68rem'}`,
              justifyContent: `${rtlList.includes(language) ? 'flex-start' : 'center'}`,
              opacity: `${showAnother.anotherCp.duid != 'Yayya' ? 1 : 0}`,
              pointerEvents: `${showAnother.anotherCp.duid != 'Yayya' ? 'auto' : 'none'}`,
            }}
            onClick={() => this.openMyCard()}
          >
            <img className="icons" src="/img/activity/couplesNew/change_icon.png"></img>
            <div className="texts">{lang.switch_cp}</div>
          </div>

          <div className="left-in" onClick={() => jumpToUser(userInfo.uid)}>
            <img src="/img/activity/couplesNew/flexd_cp_header.png" className="header-img" />
            <img className="atv-img" src={userInfo.avatarurl} />
            <div className="name-text">{userInfo.nickname}</div>
          </div>
          <div className="in-the-conten">
            <div className="live-icon">
              <div className="num-text" style={{ opacity: `${showAnother.days > 0 ? 1 : 0}` }}>
                {showAnother.days}
              </div>
              <div className="days-text" style={{ opacity: `${showAnother.days > 0 ? 1 : 0}` }}>
                {lang.days}
              </div>
            </div>
            <div
              className="live-text"
              style={{ opacity: `${showAnother.anotherCp.duid != 'Yayya' ? 1 : 0}` }}
            >
              <img
                className="live-left"
                src={
                  rtlList.includes(language)
                    ? '/img/activity/couplesNew/live_right_img.png'
                    : '/img/activity/couplesNew/live_left_img.png'
                }
              ></img>
              <div className="live-contenr">
                <span>{showAnother.level.title || ''}</span>
              </div>
              <img
                className="live-right"
                src={
                  rtlList.includes(language)
                    ? '/img/activity/couplesNew/live_left_img.png'
                    : '/img/activity/couplesNew/live_right_img.png'
                }
              ></img>
            </div>
            <div
              className="progress-bar"
              style={{ opacity: `${showAnother.anotherCp.duid != 'Yayya' ? 1 : 0}` }}
            >
              <img className="icon" src="/img/activity/couplesNew/noe_icon.png" />
              <div
                className="progress"
                style={{ [rtlList.includes(language) ? 'marginRight' : 'marginLeft']: '-0.24rem' }}
              >
                <img
                  className="progress-img"
                  style={{
                    [rtlList.includes(language) ? 'right' : 'left']: `${this.progrFn()}`,
                  }}
                  src="/img/activity/couplesNew/img_inset_progress.png"
                ></img>
                <span
                  style={{
                    position: 'sticky',
                    zIndex: '16',
                    [rtlList.includes(language) ? 'marginRight' : 'marginLeft']: `${
                      chanegCp.level.score.length > 8 ? '0.24rem' : '0'
                    }`,
                  }}
                >
                  {showAnother.level.score + ' / ' + this.upShwo(showAnother.nextLevel.score)}
                </span>
              </div>
            </div>
          </div>
          <div className="right-in" onClick={() => jumpToUser(showAnother.anotherCp.uid)}>
            <img src="/img/activity/couplesNew/flexd_cp_header.png" className="header-img" />
            <img className="atv-img" src={showAnother.anotherCp.avatarurl} />
            <div className="name-text">
              {showAnother.anotherCp.duid == 'Yayya'
                ? lang.watText
                : showAnother.anotherCp.nickname}
            </div>
          </div>
        </div>
        {true && (
          <div
            className="show-rules-modle"
            style={{
              opacity: `${showModalValue == 0 ? '0' : '1'}`,
              pointerEvents: `${showModalValue == 0 ? 'none' : 'auto'}`,
            }}
            onClick={(e) => {
              this.setState({ showModalValue: 0 })
              e.stopPropagation()
            }}
          >
            {showModalValue == 1 && (
              <div
                className="cp-change-item-root"
                style={{ height: `${!hadOne ? '10.8rem' : '5.26rem'}` }}
              >
                <img className="top-bg" src="/img/activity/couplesNew/cp_item_top_bg.png"></img>
                <img
                  className="title"
                  src={`/img/activity/couplesNew/cp_modal_${language}.png`}
                ></img>
                <div
                  className="root-show"
                  onScroll={(e) => this.shoScroll(e)}
                  style={{
                    height: `${!hadOne ? '9.84rem' : 'auto'}`,
                    overflowY: `${!hadOne ? 'scroll' : 'hidden'}`,
                  }}
                  onClick={(e) => {
                    e.stopPropagation()
                  }}
                >
                  {myCpList.length > 0 &&
                    myCpList.map((item, index) => (
                      <div className="item" key={index} onClick={() => this.setInfoItem(index)}>
                        <div className="top">
                          <div className="inleft" onClick={() => this.setDomew(item)}>
                            <span>{lang.unbind}</span>
                          </div>
                          <img
                            className="inright"
                            src={
                              changeItem == index
                                ? '/img/activity/couplesNew/in_the_selecr.png'
                                : '/img/activity/couplesNew/no_the_selecr.png'
                            }
                          ></img>
                        </div>
                        <div className="body-item">
                          <div className="live-text">
                            <img
                              className="live-left"
                              src={
                                language !== 'ar'
                                  ? '/img/activity/couplesNew/live_left_img.png'
                                  : '/img/activity/couplesNew/live_right_img.png'
                              }
                            ></img>
                            <div className="live-contenr">
                              <span>{item.level.title}</span>
                            </div>
                            <img
                              className="live-right"
                              src={
                                rtlList.includes(language)
                                  ? '/img/activity/couplesNew/live_left_img.png'
                                  : '/img/activity/couplesNew/live_right_img.png'
                              }
                            ></img>
                          </div>
                          <div className="cp-item-info-root">
                            <div className="atv-info">
                              <img
                                className="haeder-img"
                                src="/img/activity/couplesNew/flexd_cp_header.png"
                              ></img>
                              <img className="atv-user" src={item.cp1.avatarurl}></img>
                              <div className="name-user">{item.cp1.nickname}</div>
                            </div>
                            <div className="in-center">
                              <div
                                className="heat-red-svga"
                                id={`heat-red-svga${index}`}
                                src="/img/activity/couplesNew/ani_profile_cp_heart.svga"
                              ></div>
                              {showSvga && (
                                <img
                                  className="imgheat-red-svga"
                                  src="/img/activity/couplesNew/weds_live.png"
                                ></img>
                              )}
                              <div className="day-num">
                                <div className="num">{item.days}</div>
                                <div className="texts">{lang.days}</div>
                              </div>
                              <div
                                className="pro-root"
                                style={{
                                  [rtlList.includes(language) ? 'marginRight' : 'marginLeft']: '0',
                                }}
                              >
                                <img
                                  className="icons"
                                  src="/img/activity/couplesNew/noe_icon.png"
                                ></img>
                                <div
                                  style={{
                                    [rtlList.includes(language) ? 'marginRight' : 'marginLeft']:
                                      '-0.24rem',
                                  }}
                                  className="por-div"
                                >
                                  <img
                                    className="progress-img"
                                    style={{
                                      [rtlList.includes(language) ? 'right' : 'left']:
                                        `${this.progrFnItem(item)}`,
                                    }}
                                    src="/img/activity/couplesNew/img_inset_progress.png"
                                  ></img>
                                  <span style={{ zIndex: '24', position: 'sticky' }}>
                                    {item.level.score + ' / ' + this.upShwo(item.nextLevel.score)}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="atv-two">
                              <img
                                className="haeder-img"
                                src="/img/activity/couplesNew/flexd_cp_header.png"
                              ></img>
                              <img className="atv-user" src={item.cp2.avatarurl}></img>
                              <div className="name-user">{item.cp2.nickname}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  {!hadOne && (
                    <div className="confim-btn" onClick={() => this.changeCpObj()}>
                      {lang.confirm}
                    </div>
                  )}
                  {!hadOne && <div style={{ height: '2rem', width: '3rem' }}></div>}
                  {!hadOne && <div className="heide-root"></div>}
                </div>
              </div>
            )}
            <div
              className="rules-modal"
              style={{
                opacity: `${showModalValue == 2 ? '1' : '0'}`,
                pointerEvents: `${showModalValue == 2 ? 'auto' : 'none'}`,
              }}
            >
              <div className="rules_title">
                <p>{lang.rules}</p>
                {/* <img className="title" src={`/img/activity/couplesNew/ruels_modal_title_${language}.png`}></img> */}
              </div>
              <div className="text-all-cs">{lang.rules_description1}</div>
              <img className="rules-modal-img" src={rulesLink}></img>
              <div className="text-all-cs">{lang.rules_description2}</div>
              <div className="text-all-cs">{lang.rules_description3}</div>
            </div>
            {showModalValue == 2 && (
              <img
                className="close-icon-rules"
                src="/img/activity/couplesNew/rules_modal_close.png"
                onClick={() => this.setState({ showModalValue: 0 })}
              ></img>
            )}
          </div>
        )}
        {showOlsdModal > 0 && (
          <div className="conf-modal">
            <div className="config-root">
              <div className="tips">{lang.unbind_pop_up(delName, delUid)}</div>
              <div className="btn-root">
                <div className="close-btn" onClick={() => this.setState({ showOlsdModal: 0 })}>
                  {lang.cancel}
                </div>
                <div className="cofin-btn" onClick={() => this.closeCpfn()}>
                  {lang.confirm}
                </div>
              </div>
            </div>
          </div>
        )}
        <Toast language={language} lang={lang} ref="toast" id="toast" toastContent={toastContent} />
        <MediaModal visible={mediaVisible} media={activeMedia} onClose={this.onCloseMediaModal} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/couplesNew/index.js